<template>
  <div class="default-layout">
    <main-header
      :is-open-sidebar="isOpenSidebar"
      @toggle-sidebar="toggleSidebar"
    />

    <sidebar
      :is-open-sidebar="isOpenSidebar"
      @toggle-sidebar="toggleSidebar"
    />

    <main class="content">
      <slot />
    </main>

    <modal-render />

    <notifications position="top right" />
  </div>
</template>

<script>
import MainHeader from '@/components/mainHeader'
import Sidebar from '@/components/sidebar'

export default {
  name: 'DefaultLayout',
  data () {
    return {
      isOpenSidebar: false
    }
  },
  components: {
    MainHeader,
    Sidebar,
    ModalRender: () => import('@/components/modals/modalRender')
  },
  methods: {
    toggleSidebar () {
      this.isOpenSidebar = !this.isOpenSidebar
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-left: 290px;
  padding: 73px 10px 0 10px;
  min-height: 100vh;
}

@media (max-width: 768px) {
  .content {
    margin-left: 0;
    padding: 75px 10px 25px;
  }
}
</style>
